import { useFormHandler } from "@/hooks/useFormHandler";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { auth } from "@/endpoints/dryp/auth";
import { z } from "zod";
import { validation } from "@/domain/validation";

const validationFromSchema = z.object({
	email: validation.email,
});
type ForgotPasswordFormValues = z.infer<typeof validationFromSchema>;

export const useForgotPassword = () => {
	const forgotPasswordApi = useAsyncStateStore(auth.forgotPassword);

	const { form, handleFormErrors } = useFormHandler(validationFromSchema, { defaultValues: { email: "" } });

	const onSubmit = async ({ email }: ForgotPasswordFormValues) => {
		try {
			await forgotPasswordApi.fetch({ email });
		} catch (error) {
			handleFormErrors(error);
		}
	};

	const { success, error, loading } = forgotPasswordApi;

	return {
		form,
		onSubmit,
		showFormContent: !success,
		error,
		loading,
	};
};
